<app-menu>
    <div class="header">
      <h1>View Rates</h1>
    </div>
    <mat-tab-group (selectedTabChange)="onTabChange($event)" style="height: 92%; width: 100%;">
      <mat-tab label="Market Rates">
        <div style="padding: 16px;">
          <span>This tab is a proof of concept. Data will be cleaned before production.</span>
          <!-- I removed the *ngIf to have the grid rendered faster-->
          <div class="ag-theme-ulaap" style="width: 100%; height: 400px;">
            <ag-grid-angular
              style="width: 100%; height: 100%;"
              [columnDefs]="defaultColumnDefs"
              [defaultColDef]="defaultColDef"
              [rowData]="defaultRowData"
              [class]="themeClass"
              [gridOptions]="defaultGridOptions"
              (gridReady)="onGridReady($event, 'default')"
              [detailCellRenderer]="detailCellRenderer"
              [masterDetail]="true"
              [detailRowHeight]="500">
            </ag-grid-angular>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Customer Rates">
        <div style="padding: 16px;">
          <div class="ag-theme-ulaap" style="width: 100%; height: 400px">
            <ag-grid-angular
            style="width: 100%; height: 100%;"
            [columnDefs]="customerColumnDefs"
            [defaultColDef]="defaultColDef"
            [rowData]="customerRowData"
            [class]="themeClass"
            [gridOptions]="customerGridOptions"
            (gridReady)="onGridReady($event, 'customer')"
            [detailCellRenderer]="detailCellRenderer"
            [masterDetail]="true"
            [detailRowHeight]="500"
            (cellEditingStopped)="onCellEditingStopped($event)"
            (cellEditingStarted)="onCellEditingStarted($event)">
          </ag-grid-angular>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Carrier Rates">
        <div style="padding: 16px;">
          <div class="ag-theme-ulaap" style="width: 100%; height: 400px">
            <ag-grid-angular
            [rowData]="carrierRowData"
            style="width: 100%; height: 100%;"
            [columnDefs]="carrierColDefs"
            [defaultColDef]="defaultColDef"
            [class]="themeClass"
            [gridOptions]="carrierGridOptions"
            (gridReady)="onGridReady($event, 'carrier')"
            [detailCellRenderer]="detailCellRenderer"
            [masterDetail]="true"
            [detailRowHeight]="500"
            (cellEditingStopped)="onCellEditingStopped($event)"
            (cellEditingStarted)="onCellEditingStarted($event)">
            ></ag-grid-angular>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
    <div id="modalBackdrop" *ngIf="editModal">
      <div id="editModal">
        <h4>Are you sure want to save this rate edit?</h4>
        <button mat-raised-button color="primary" (click)="submitRateEdit()">Yes</button>
        <button mat-raised-button (click)="undoRateEdit()">Cancel</button>
      </div>
    </div>
  </app-menu>


<!-- <app-menu>
    <div class="header">
        <h1>View Rates</h1>
    </div>    
    <mat-tab-group (selectedTabChange)="onTabChange($event)" style="height:92%; width: 100%;">
        <mat-tab label="Market Rates">
            <span>This tab is a proof of concept. Data will be cleaned before production.</span>
            <ag-grid-angular *ngIf="gridReady"
            style="width: 90%; height: 70%"
            [columnDefs]="columnDefs"
            [rowData]="rowData"
            [class]="themeClass"
            (gridReady)="onGridReady($event)"
            >
            </ag-grid-angular>
        </mat-tab>
        <mat-tab label="Customer Rates"></mat-tab>
        <mat-tab label="Carrier Rates"></mat-tab>
    </mat-tab-group>

</app-menu> -->
